<template>
  <div>
    <vue-headful title="Diploma's" />
    <Header page_title="Diploma's" />
    <div class="app-body container-fluid">
      <NotificationContainer />
      <h2 class="sd-title right-line small mb-20px">
        <span class="title-text"><svg-icon icon="diploma" />Jouw diploma's & certificaten</span>
      </h2>
      <div class="diploma-container">
        <div class="upload-diploma">
          <span class="extra-info"><svg-icon icon="information" />Upload tot maximaal 5 diploma's en/of certificaten</span>
          <div v-for="file in displayFiles" :key="file.id">
            <hr>
            <div v-if="file != null" class="upload-info-container">
              <svg-icon icon="file_layout" />
              <div class="upload-info">{{ file.original_filename }}</div>
              <span v-if="file.status == 'pending'" class="upload-info">status: <span class="upload-status-new">in afwachting</span></span>
<!--              <span v-else-if="file.status == 'approved'" class="upload-info">status: <span class="upload-status-approved">goedgekeurd</span></span>-->
<!--              <span v-else-if="file.status == 'rejected'" class="upload-info">status: <span class="upload-status-rejected">afgekeurd</span></span>-->
<!--              <span v-else-if="file.status == 'new'" class="upload-info">status: <span class="upload-status-new">nieuw</span></span>-->
            </div>
          </div>
          <div :hidden="this.allowedNewUploads <= 0">
            <label class="btn btn-gray btn-block">
              <span>Klik hier om een diploma te uploaden</span>
              <input
                :id="'diploma-upload-' + Object.keys(displayFiles).length"
                type="file"
                :ref="'diploma_image_' + Object.keys(displayFiles).length"
                @change="onFileUpload(Object.keys(displayFiles).length)"
                accept="image/x-png, image/jpeg, .doc, .docx, .ppt, .pptx, .txt, .pdf"
                class="btn btn-gray btn-block"
                style="display: none"
              />
            </label>
          </div>
        </div>
        <div class="upload-buttons">
          <span v-if="this.hasRejectedFiles" class="extra-info mt-1 mb-4"><svg-icon icon="warning" />Upload tot maximaal 3 diploma's en/of certificaten</span>
          <button
            type="button"
            class="btn btn-warning btn-block mt-2"
            @click="onSave"
            :disabled="!hasUploadedFile"
          >
            Opslaan
          </button>
        </div>
        <Footer />
      </div>
    </div>

  </div>
</template>

<script>
import VueSlideBar from "vue-slide-bar";
export default {
  components: {
    VueSlideBar
  },
  data: function() {
    return {
      user: "",
      branch: "",
      sub_branch: "",
      displayFiles: [],
      uploadedFiles: [],
      newFiles: [],
      saveOnUpdate: false,
      hasUploadedFile: false,
      hasRejectedFiles: false,
      allowedNewUploads: ""
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.branch = localStorage.getItem("branch");
      this.sub_branch = localStorage.getItem('subBranch');
      this.allowedNewUploads = this.allowedUploads();

      return new Promise((resolve, reject) => {
        var url = this.$apiURI + "/applicant/uploads/diplomas/get/" + this.user.id;
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data) {
              if (resp.data.length > 0) {
                for (var i = 0; i < resp.data.length; i++) {
                  var newEntry = new Array();
                  newEntry.id = resp.data[i].id;
                  newEntry.user_id = resp.data[i].user_id;
                  newEntry.file = resp.data[i].file;
                  newEntry.original_filename = resp.data[i].original_filename;
                  newEntry.status = resp.data[i].status;
                  this.displayFiles.push(newEntry);

                  if (resp.data[i].status != 'rejected') { //Check if status == rejected
                    this.allowedNewUploads = this.allowedNewUploads - 1;
                  } else {
                    this.hasRejectedFiles = true;
                  }
                }
              }
            }
            return resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
          });
      });
    },
    async saveDiplomas() {
      return new Promise(resolve => {
        window.scrollTo(0, 0);
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant/uploads/diplomas/new";
        let formData = new FormData();
        for (let i = 0; i < Object.keys(this.uploadedFiles).length; i++) {
          this.uploadedFiles[i]["photoNumber"] = i;
          let nameOfFile = "uploadedFile-" + i;
          formData.append(nameOfFile, this.newFiles[i]);
          formData.append("userId", this.user.id);
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async setSuccessNotification() {
      const notification = {
        type: "success",
        message: "Jouw diploma's zijn opgeslagen. We controleren ze zo snel mogelijk."
      };
      this.$store.dispatch("notification/replace", notification, {
        root: true
      });
    },
    onFileUpload(index) {
      let fullPath = document.getElementById('diploma-upload-' + index).value;
      if (fullPath == null || fullPath == "") {
        return;
      }
      this.hasUploadedFile = true;
      this.allowedNewUploads = this.allowedNewUploads - 1;
      let fileName = fullPath.split(/(\\|\/)/g).pop();
      let uploadIndex = Object.keys(this.uploadedFiles).length;
      console.log("onFileUpload: " + fileName);
      let newEntry = {
        id: null,
        userId: this.user.id,
        status: 'new',
        file: fileName,
        original_filename: fileName
      };
      let refName = "diploma_image_" + index;
      this.$set(this.newFiles, uploadIndex, this.$refs[refName].files[0]);
      this.$set(this.uploadedFiles, uploadIndex, newEntry);
      this.$set(this.displayFiles, index, newEntry);
    },
    async onSave() {
      this.$store.state.loading = true;
      await this.saveDiplomas();
      await this.setSuccessNotification();
      this.hasUploadedFile = false;
      this.$store.state.loading = false;
    },
    allowedUploads() {
      if(this.branch === "1" && (this.sub_branch === '2' || this.sub_branch === '1,2')) {
        return 5;
      }else {
        return 3;
      }
    }
  }
};
</script>

<style scoped>
.btn-gray {
  margin: 20px 0 0;
}
.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

/deep/.upload-info-container .svg-container {
  color: #FFCD00;
}

.upload-info {
  width: unset;
  margin-left: 10px;
}

#collapseEducation ul li {
  margin-bottom: 5px;
}
section.block.border-bottom ul label.float-left.educ {
  height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-y: visible;
  overflow: hidden;
}
section.block.border-bottom ul .float-left.val.educ {
  height: 25px;
}
#collapseEducation ul li > div:not(:first-child) .val {
  position: relative;
  height: auto;
  line-height: 100%;
  padding: 3px 0;
}

section.block.border-bottom button[data-toggle="collapse"] {
  font-size: 17px;
  font-family: "Real Head Pro";
  font-weight: normal;
  border: none;
  background: none;
  padding: 0;
  color: #625a55;
  outline: none;
  width: 100%;
  position: relative;
  top: 4px;
}
section.block.border-bottom button[data-toggle="collapse"] i {
  color: #FFCD00;
  font-size: 26px;
  position: relative;
  top: -4px;
}
section.block.border-bottom button[aria-expanded] span.float-right {
  position: relative;
  display: none;
  right: -11px;
  top: 4px;
  width: 30px;
  height: 18px;
}
section.block.border-bottom button[aria-expanded="false"] span.right {
  display: block;
}
section.block.border-bottom button[aria-expanded="true"] span.down {
  display: block;
}
#app section.block.border-bottom .collapse label.educ {
  overflow:visible;
  white-space:normal;
  text-overflow:unset;
  height: inherit;
  top:0;
  line-height:normal;
}
#app section.block.border-bottom .collapse .clearfix.text-14{
  display:flex;
  height:auto;
  line-height: normal;
  min-height: 20px;
  padding: 3px 0;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *{
  float:none !important;
  flex: 50%;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *:last-child{
  height: inherit;
  position: relative;
  align-self: flex-end;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *:last-child > *{
  display:inline-block;
  line-height: normal;
}
@media screen and (max-width: 375px){
  section.block.border-bottom button {
    width: calc(100% + 5px) !important;
  }
}

</style>
